'use client';

export const initScroller = () => {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line -- smooth-scroll does not handle for server-side imports lacking a window object
    const SmoothScroll = require('smooth-scroll');

    window.scroller = new SmoothScroll('a[href*="#"]', {
      updateURL: false,
      popstate: false,
      easing: 'easeInOutCubic',
      speed: 400,
      speedAsDuration: true,
      offset: (anchor) => (anchor.offsetTop > 50 ? 50 : 0),
    });

    window.scroller.anchorScroll = (anchor) => {
      return new Promise((resolve, _reject) => {
        const unbindAndResolve = () => {
          document.removeEventListener('scrollStop', unbindAndResolve, false);
          document.removeEventListener('scrollCancel', unbindAndResolve, false);

          resolve();
        };

        document.addEventListener('scrollStop', unbindAndResolve, false);
        document.addEventListener('scrollCancel', unbindAndResolve, false);

        window.scroller.animateScroll(document.querySelector(anchor));
      });
    };
  }
};
